export const DATA_ERROR = 'Data object must be provided on the route data property';
export const FEATURE_ID_ERROR = 'Feature id must be provided on the route data property';
export const MISSING_PROPERTY_ERROR = 'A property is missing on the route data property';
